'use client'

import { Skeleton } from '@achra/ui/skeleton'
import { usePathname } from 'next/navigation'

function BuilderHeaderDescriptionSkeleton() {
  const pathname = usePathname()
  const isBudgetStatements = pathname.includes('budget-statements')

  if (isBudgetStatements) {
    return null
  }

  return (
    <div className="flex flex-col gap-1 md:pl-14">
      <Skeleton className="h-5 w-full" />
      <Skeleton className="h-5 w-1/3" />
    </div>
  )
}

export { BuilderHeaderDescriptionSkeleton }
